import script from "./PgmBankbookUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmBankbookUpload.vue?vue&type=script&setup=true&lang=ts"

import "./PgmBankbookUpload.vue?vue&type=style&index=0&id=837c702c&lang=scss"

const __exports__ = script;

export default __exports__